/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Mxf_WrapInputs */

const en_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF Wrap`)
};

const fr_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enveloppe MXF`)
};

const de_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF Wrap`)
};

const it_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF Wrap`)
};

const ru_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF-пленка`)
};

const es_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoltura MXF`)
};

const zh_cn2_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF 包覆`)
};

const ja_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXFラップ`)
};

const hi_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एमएक्सएफ रैप`)
};

const pt_pt2_subtitle_export_mxf_wrap = /** @type {(inputs: Subtitle_Export_Mxf_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoltório MXF`)
};

/**
* | output |
* | --- |
* | "MXF Wrap" |
*
* @param {Subtitle_Export_Mxf_WrapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_mxf_wrap = /** @type {((inputs?: Subtitle_Export_Mxf_WrapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Mxf_WrapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_mxf_wrap(inputs)
	if (locale === "de") return de_subtitle_export_mxf_wrap(inputs)
	if (locale === "it") return it_subtitle_export_mxf_wrap(inputs)
	if (locale === "ru") return ru_subtitle_export_mxf_wrap(inputs)
	if (locale === "es") return es_subtitle_export_mxf_wrap(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_mxf_wrap(inputs)
	if (locale === "ja") return ja_subtitle_export_mxf_wrap(inputs)
	if (locale === "hi") return hi_subtitle_export_mxf_wrap(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_mxf_wrap(inputs)
	return en_subtitle_export_mxf_wrap(inputs)
});